<template>
  <!---环境数据--->
  <div class="container">
    <crumb :prevLevel="prevLevel" current="环境数据" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="enterpriseType + '企业名称'">
              <el-input
                v-model="entName"
                :placeholder="`请输入${enterpriseType}企业名称`"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="监测点类型">
              <el-select v-model="storehouseType">
                <el-option label="全部" value="" />
                <el-option label="库房温湿度" value="库房温湿度" />
                <el-option label="生产车间温湿度" value="生产车间温湿度" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="监测点名称">
              <el-input
                v-model="storehouseName"
                placeholder="请输入监测点名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button type="primary" style="margin-left:20px" @click="init()"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="title">环境监测点数量统计</div>
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ envNumAll }}</div>
            <div class="text">{{ enterpriseType }}企业数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ envMonitorNumAll }}</div>
            <div class="text">环境监测点数量</div>
          </div>
        </div>
        <Echarts :echartsOption="echartsOption" echartsHeight="400px" />
      </div>
    </div>
    <div class="table-list">
      <div class="title">环境监测点列表</div>
      <el-table :data="supplierList" class="table">
        <el-table-column prop="ent_name" :label="enterpriseType + '企业名称'" />
        <el-table-column prop="storehouse_type" label="监测点类型" />
        <el-table-column prop="storehouse_name" label="监测点名称" />
        <el-table-column label="监测点详情">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="font-size: 12px"
              @click="checkDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
import enterpriseTypeMixin from './enterprise-type.mixin';
import paginationMixin from './pagination.mixin';

export default {
  data() {
    return {
      URL: '',
      handlerName: '',
      joint: '',
      envNumAll: '',
      envMonitorNumAll: '',
      type: '',
      entName: '',
      storehouseType: '',
      storehouseName: '',
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              textStyle: {
                color: '#666'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: '#386CE2'
            },
            data: []
          }
        ]
      },
      supplierList: [],
      chartsUrl: ''
    };
  },
  mixins: [enterpriseTypeMixin, paginationMixin],
  components: {
    Echarts,
    Crumb
  },
  mounted() {
    if (this.prevLevel === '生产数据监管') {
      this.URL = 'open/statistic/reportData';
      this.handlerName = 'env_monitor_pro_list';
      this.chartsUrl = 'rest/production/environmentalMonitorScStatics';
    }
    if (this.prevLevel === '流通数据监管') {
      this.URL = 'rest/statistic/reportData';
      this.handlerName = 'env_monitor_list';
      this.chartsUrl = 'rest/circulation/environmentalMonitorStatics';
    }
    this.init();
  },
  methods: {
    init() {
      this.queryParams();
      this.EchartsData();
    },
    // 列表
    queryParams() {
      this.$request({
        url: this.URL,
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: this.currentPage, pageSize: this.pageSize },
            params: {
              handlerName: this.handlerName,
              entName: this.entName,
              storehouseName: this.storehouseName,
              storehouseType: this.storehouseType
            }
          })
        }
      }).then(res => {
        this.supplierList = res
          ? res.list.map(item => ({
              ...item
            }))
          : [];
        this.total = res ? res.total : 0;
      });
    },
    // ecarts 柱状图
    EchartsData() {
      const xData = [];
      const yData = [];
      this.$request({
        url: this.chartsUrl,
        data: {
          json: JSON.stringify({
            dict: {},
            params: {
              entName: this.entName,
              storehouseName: this.storehouseName,
              storehouseType: this.storehouseType
            }
          })
        }
      }).then(res => {
        this.envNumAll = res.envNumAll;
        this.envMonitorNumAll = res.envMonitorNumAll;
        res.list.forEach(item => {
          xData.push(item.ent_name);
          yData.push(item.num);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    },
    checkDetail(row) {
      let type = '';
      // this.joint = row.storehouse_type + '-' + row.storehouse_name;
      if (this.prevLevel === '生产数据监管') {
        type = 'productingEnterprise/monitorDetail';
      } else {
        type = 'circulateEnterprise/circulateMonitorDetail';
      }

      this.$router.push({
        path: `/page/${type}/EnvironmentDetail`,
        query: {
          entName: row.ent_name,
          entType: row.ent_type,
          storeHouseType: row.storehouse_type,
          storeHouseName: row.storehouse_name,
          storeHouseAddress: row.storehouse_address
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
</style>
